// removed by extract-text-webpack-plugin
module.exports = {"period":"_5vVd5","subperiod":"_2rXaX _5vVd5","title":"_3I11s","link":"qeWXg","expandButton":"_3TO5O","count":"Ic3WE","thumbnails":"_3xKJx","thumbnail":"_2ZmAg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TimelinePeriod.css
// module id = 810
// module chunks = 0